import { type QueryClient } from '@tanstack/react-query';

import { getData } from 'api/requests/GET_SHOWCASES';

import { getQueryKey } from 'helpers/getQueryKey';

export const getShowcasesOptions = () => {
  return {
    queryKey: getQueryKey('SHOWCASES'),
    queryFn: () => {
      return getData();
    },
  };
};

export const queryShowcases = (client: QueryClient) => {
  return client.ensureQueryData(getShowcasesOptions());
};
